import React, { Fragment } from 'react';
import ListBox from '../../../../../../components/outline/ListBox';
import Button from '../../../../../../components/Button';
import Table from '../../../../../../components/_table/Table';
import { _LIST_PAGINATION_MODEL } from '../../../../../../store/modules/app/models';
import columns from './columns';
import './OrderReturnManagementList.scss';

const OrderReturnManagementList = (props) => {
  const {
    orderReturnManagementList,
    orderReturnManagementSelectedList,
    getList,
    onCheckOrderItem,
    getAllListExcelDownload,
    getSelectedListExcelDownload,
    completeCollectionOrderReturn,
    failCollectionRejectOrderReturn,
    editReasonOrderReturn,
    completeOrderReturn,
    rejectOrderReturn,
    changeReturnToExchange,
    getOrderReturnAttachment,
  } = props;
  const { list, filterOption, pagination } = orderReturnManagementList;

  return (
    <ListBox
      className="order-return-management-list"
      head={
        <div className="excel-btn-area">
          <Button isRadius={true} text="선택 주문 엑셀 다운로드" onClick={() => getSelectedListExcelDownload()} />
          <Button isRadius={true} text="전체 주문 엑셀 다운로드" onClick={() => getAllListExcelDownload()} />
        </div>
      }
      body={
        <Fragment>
          <div className="order-return-management-list-body-area">
            <div className="left-btn-area">
              <div className="button-form">
                <div className="label">반품 수거 여부</div>
                <div className="button-list">
                  <Button text="수거 완료처리" onClick={() => completeCollectionOrderReturn()} />

                  <Button text="수거 실패 -> 반품 거부 처리" onClick={() => failCollectionRejectOrderReturn()} />
                </div>
              </div>
            </div>
            <div className="right-btn-area">
              <div className="button-form">
                <div className="label">반품 정보 수정</div>
                <div className="button-list">
                  <Button text="반품 사유 수정" onClick={() => editReasonOrderReturn()} />
                </div>
              </div>
            </div>
            <div className="full-btn-area">
              <div className="button-form">
                <div className="label">반품 처리</div>
                <div className="button-list">
                  <Button text="반품 승인 처리" onClick={() => completeOrderReturn()} />

                  <Button text="반품 거부 처리" onClick={() => rejectOrderReturn()} />

                  <Button text="반품 -> 교환으로 변경" onClick={() => changeReturnToExchange()} />
                </div>
              </div>
            </div>
          </div>

          <Table
            className="order-return-management-list-table"
            rowKey={(record) => record.orderItemId}
            list={list}
            onCheck={(data) => onCheckOrderItem(data)}
            selectedList={orderReturnManagementSelectedList}
            initialOption={{
              pagination: _LIST_PAGINATION_MODEL,
            }}
            filterOption={filterOption}
            pagination={pagination}
            getList={getList}
            scroll={{ x: true }}
            columns={(utils) =>
              columns({
                ...utils,
                getOrderReturnAttachment,
              })
            }
          />
        </Fragment>
      }
    />
  );
};

export default OrderReturnManagementList;
